import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter} from 'react-router-dom'
import Button from '../components/uiKit/Button'
import Icon from '../components/misc/Icons'
import {showNotification} from '../actions/notifications'
import {dismissDomainMatchModal} from '../actions/isbeDomainMatch'
import {addGoogleSignin} from '../actions/user'
import {fetchIdentities} from '../actions/identities'
import {isbeOptIn} from '../actions/isbeDomainMatch'
import GoogleLogin from 'react-google-login'
import errorMessages from '../errorMessages.js'


  
const responseGoogle = (response) => {}



class DomainMatchModal extends Component {

	constructor(){
		super()				
		this.handleBackgroundClick=this.handleBackgroundClick.bind(this)
		this.state={
			isbeSectionCount:0
		}     
	}
 


	UNSAFE_componentWillMount() {
		document.body.style.overflowY='hidden' //prevent scrolling while modal is open
		let isbeSectionCount=0
		this.props.fetchIdentities().then((response) => {
			response.map((identity)=>{
				isbeSectionCount+=identity.sectionCount
				return null
			})
			this.setState({isbeSectionCount:isbeSectionCount})
		})
			.catch(error => {
				
			})


	}

  
	componentDidMount(){
		if(window.analytics){
			const autoDisplayed=window.location.hash !== '#isbe-connect'		
			window.analytics.page('ISBE Domain Match Modal',{
				autoDisplayed:autoDisplayed,
				hasGoogleSignin:this.props.hasGoogleSignin
			})
		}
	}



 	componentWillUnmount() {
		document.body.style.overflowY='' // overlay is not supported by firefox, so default to blank (auto style comes from css)
		document.body.style.overflowY='overlay' // overlay is to prevent windows scrollbars interacting with pagewidth
	}

	handleBackgroundClick(e){
		if (e.target === e.currentTarget) this.props.dismissDomainMatchModal() //close modal is click outside modal
	}


	
	render() {
		
		const {hasGoogleSignin,user,submitLoading} = this.props
		const {isbeSectionCount}=this.state

		const isbeEndDate ='July 31, 2020'

		const isbeConnectedClassCount = isbeSectionCount

		let isbeConnectedClassCountDescription

		if(isbeConnectedClassCount === 0){
			isbeConnectedClassCountDescription = 'no classes'
		}
		else if(isbeConnectedClassCount === 1){
			isbeConnectedClassCountDescription = '1 class'
		}
		else{
			isbeConnectedClassCountDescription = `${isbeConnectedClassCount} classes`
		}

		


		return (			
			<div className='ISBEDomainMatchModalContainer' onClick={this.handleBackgroundClick}>				

				<div className='ISBEDomainMatchModal'>

					<div className='ISBEDomainMatchModal-closeBtn' onClick={this.props.dismissDomainMatchModal}>
						<Icon name='circle-with-close' />
					</div>

					<div className='ISBEDomainMatchModal-h1'>
						Great News
					</div>
					<div className='ISBEDomainMatchModal-h2'>
						Thanks to a partnership between Plickers and the Illinois State Board <br/> of Education, <b>you’re eligible to connect your account to Ed360.</b>
					</div>
					<a className='ISBEDomainMatchModal-ISBEInfoLink' href='https://www.isbe.net/ed360' target='_blank' rel='noopener noreferrer'>
						Click here to learn more about Ed360
					</a>
					<div className='ISBEDomainMatchModal-benefitsHeader'>
						What's included
					</div>

					<div className='ISBEDomainMatchModal-benefitsContainer'>
						<div className='ISBEDomainMatchModal-benefit'>
							<div className='ISBEDomainMatchModal-benefit-number'>							
								1
							</div>
							<div className='ISBEDomainMatchModal-benefit-header'>							
								Plickers Pro
							</div>
							<div className='ISBEDomainMatchModal-benefit-desc'>							
								No Set Limits, Shared Packs, Unlimited Scoresheet and more.
							</div>
						</div>
						<div className='ISBEDomainMatchModal-benefit'>
							<div className='ISBEDomainMatchModal-benefit-number'>							
								2
							</div>
							<div className='ISBEDomainMatchModal-benefit-header'>							
								Pre-Rostered Classes
							</div>
							<div className='ISBEDomainMatchModal-benefit-desc'>							
								Responses are synchronized with your Ed360 account. You have {isbeConnectedClassCountDescription} pre-rostered so far.
							</div>
						</div>
						<div className='ISBEDomainMatchModal-benefit'>
							<div className='ISBEDomainMatchModal-benefit-number'>							
								3
							</div>
							<div className='ISBEDomainMatchModal-benefit-header'>							
								Question Bank
							</div>
							<div className='ISBEDomainMatchModal-benefit-desc'>							
								Any Illinois-exclusive content shared by Ed360.
							</div>
						</div>
						<div className='ISBEDomainMatchModal-benefitsCloudBG'>							
							<svg width="765" height="157" viewBox="0 0 765 157">
						  	<path d="M15.1380325,20.2494031 C28.7199981,-1.46634244 235.612755,2.56514859 410.618837,2.56514859 C653.733319,2.56514859 728.149411,-12.6543541 754.264981,31.0503694 C763.731677,46.8929993 772.319604,122.018979 754.264981,144.036255 C736.210358,166.053532 514.062989,152.301287 440.595704,153.565149 C293.130881,156.101993 19.1388815,160.328607 6.32810893,144.036255 C-6.21722229,128.081484 1.55606698,41.9651486 15.1380325,20.2494031 Z"/>
							</svg>							
						</div>
						

					</div>										
									


					{hasGoogleSignin && 															
						<GoogleLogin
							clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
							onSuccess={(response)=>{this.props.isbeOptIn(response.code)}}
							onFailure={responseGoogle}
							className='btn btn--blue btn--xLarge ISBEDomainMatchModal-connectBtn'
							loginHint={user.email}
							accessType={'offline'}
							responseType={'code'}
							prompt={'consent'}
				 				>	
		 					{!submitLoading &&
		 						<React.Fragment>			 					
			 						<div className='ISBEDomainMatchModal-connectBtn-primary'>
										Authenticate with your Google Account to connect to Ed360
									</div>
									<div className='ISBEDomainMatchModal-connectBtn-secondary'>
									 {user.email}
									</div>
								</React.Fragment>
							}
							{submitLoading &&
								<div className='ISBEDomainMatchModal-connectBtn-submitLoading'>							 								 	
								 	<div className='ISBEDomainMatchModal-connectBtn-submitLoading-spinnerContainer'>
								 		<div className='ISBEDomainMatchModal-connectBtn-submitLoading-spinner' />
								 	</div>
								</div>
							}
						
						</GoogleLogin>
					}


					{!hasGoogleSignin && user &&
						<GoogleLogin
		 					clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
		  					onSuccess={(response)=>{this.props.addGoogleAccount(response.code)}}
		  					onFailure={responseGoogle}
		  					className='btn btn--blue btn--xLarge ISBEDomainMatchModal-connectBtn'
		  					loginHint={user.email}
		  					accessType={'offline'}
		  					responseType={'code'}
		  					prompt={'consent'}
		 				>	
		 			
		 					{!submitLoading &&
		 						<React.Fragment>			 					
			 						<div className='ISBEDomainMatchModal-connectBtn-primary'>
										Sign-in to your Google Account to connect to Ed360
									</div>
									<div className='ISBEDomainMatchModal-connectBtn-secondary'>
									 {user.email}
									</div>
								</React.Fragment>
							}
							{submitLoading &&
								<div className='ISBEDomainMatchModal-connectBtn-submitLoading'>							 								 	
								 	<div className='ISBEDomainMatchModal-connectBtn-submitLoading-spinnerContainer'>
								 		<div className='ISBEDomainMatchModal-connectBtn-submitLoading-spinner' />
								 	</div>
								</div>
							}
						
						</GoogleLogin>
					}						

					<Button label="Maybe Later" name='isbeDomainMaybeLater' size='xLarge' color='white' onClickFunction={this.props.dismissDomainMatchModal}/>

					
					<div className='ISBEDomainMatchModal-smallPrint'>
						The Ed360 connection depends on your connected school Google account.<br/>
						If you lose access to that Google account (if you leave your job, for example), the Ed360 connection will be removed.<br/>
						 Otherwise, this Ed360 connection is good through at least {isbeEndDate}.<br/>
					</div>



				</div>
							
			</div>								
		)
	}
	
	}








class IsbeDomainMatchContainer extends Component {

	constructor(){
		super()	
		this.shouldShowDomainMatchModal=this.shouldShowDomainMatchModal.bind(this)
		this.dismissDomainMatchModal=this.dismissDomainMatchModal.bind(this)
		this.addGoogleAccount=this.addGoogleAccount.bind(this)
		this.isbeOptIn=this.isbeOptIn.bind(this)

		this.state={
			submitLoading:false
		}       

	}



	addGoogleAccount(authCode){
		if(window.analytics){
			const autoDisplayed=window.location.hash !== '#isbe-connect'	
			window.analytics.track('Clicked Connect in ISBE Modal',{
				autoDisplayed:autoDisplayed,
				hasGoogleSignin:false			
			})
		}




		//now get googleUser for adding google auth to account
		const authInstance=window.gapi.auth2.getAuthInstance()
		const user= authInstance.currentUser.get()
  		if(user && user.Zi){
  			const token=user.Zi['id_token']
  			this.setState({submitLoading:true})
			const requestData={
				idToken:token
			}
			this.props.addGoogleSignin(this.props.user.id,requestData).then((response) => {
				this.props.isbeOptIn(authCode).then(()=>{
					this.dismissDomainMatchModal()
					this.setState({submitLoading:false})
				})
				if(window.analytics){
					window.analytics.track('ISBE Connect Success')
				}
			 	this.props.showNotification('to Ed360','Connected','default')
		})
		.catch(error => {
			this.dismissDomainMatchModal()
			let errorMessage='Something went wrong. Could not add Google Sign in access.'
			if(errorMessages.accountErrors.addGoogleSignin[error.response.status]){
		 		errorMessage=`${errorMessages.accountErrors.addGoogleSignin[error.response.status]}`
			}
			this.props.showNotification(errorMessage,'Error:','destroy')
			if(window.analytics){
				const errorCode=error.response.status
					window.analytics.track('ISBE Connect Failure',{
						hasGoogleSignin:false,
						errorCode:errorCode})
				}
		})
	}
}
 


	isbeOptIn(authCode){
		if(window.analytics){
			const autoDisplayed=window.location.hash !== '#isbe-connect'	
			window.analytics.track('Clicked Connect in ISBE Modal',{
				autoDisplayed:autoDisplayed,
				hasGoogleSignin:true			
			})
		}
		this.setState({submitLoading:true})
		this.props.isbeOptIn(authCode).then(()=>{
			this.dismissDomainMatchModal()
			this.setState({submitLoading:false})
			this.props.showNotification('to Ed360','Connected','default')
			if(window.analytics){
				window.analytics.track('ISBE Connect Success')
			}
		})
		.catch(error => {
			this.dismissDomainMatchModal()
			let errorMessage='Something went wrong. Could not connect to ISBE.'
			if(error.response.status===403){
				errorMessage='The Google account does not match your existing Plickers email. Please try again with a matching Google account.'
				}
				this.props.showNotification(errorMessage,'Error:','destroy')
				if(window.analytics){
					const errorCode=error.response.status
					window.analytics.track('ISBE Connect Failure',{
						hasGoogleSignin:true,
						errorCode:errorCode})
				}
			})
	}



	dismissDomainMatchModal(){
		this.setState({submitLoading:false})
		if(window.location.hash==='#isbe-connect'){
			window.location.hash=''
		}else{
			this.props.dismissDomainMatchModal()
		}
	}


	shouldShowDomainMatchModal(){
		const {meta}=this.props
		if(window.location.hash==='#isbe-connect'){
			return true
		}

		else if(!meta){
			return false
		}
		else if(meta && !meta.isbeModalSeen && meta.isbeMatchedAt && !meta.isbeOptedInAt ){
			return true

		}


		else return false
		
	}
	
	render() {

		let hasGoogleSignin=false
		if(this.props.signinMethods && this.props.signinMethods.google){
			hasGoogleSignin=true
		}
		
 

		if(this.shouldShowDomainMatchModal() ){
			return (
				<DomainMatchModal 
					dismissDomainMatchModal={this.dismissDomainMatchModal}
					hasGoogleSignin={hasGoogleSignin}
					isbeOptIn={this.isbeOptIn}
					user={this.props.user}
					addGoogleAccount={this.addGoogleAccount}
					fetchIdentities={this.props.fetchIdentities}
					submitLoading={this.state.submitLoading}
				/>
				)
			}
		else return null
	}
}





export default withRouter(connect(
	(state) => ({
		service:state.service,
		meta:state.meta,
		backToSchoolModal:state.backToSchoolModal,
		billing:state.billing,
		user:state.user,
		signinMethods:state.signinMethods,
	
	
	}),
	{ showNotification,addGoogleSignin,isbeOptIn,dismissDomainMatchModal,fetchIdentities}
)(IsbeDomainMatchContainer))






// WEBPACK FOOTER //
// ./src/containers/IsbeDomainMatchContainer.js